export default "__VITE_ASSET__9idjp0K___"